// Strip the dot from extensions
export const normalizeExtensions = (extensions) => {
    return extensions?.map((extension) => {
        return extension.startsWith(".") ? extension.slice(1) : extension;
    });
};
